<section class="toggler-container">
  <div (click)="toggleView()" #toggleButton class="view-toggler">
    <span>--</span>
  </div>

</section>

<ng-container *ngIf="!isCollapsed()">
  <div [@slideUpDown] style="padding: 26px 0 0; overflow: hidden"
       [ngStyle]="{ height: isCollapsed() ? '20px' : 'auto' }">
    <form [formGroup]="debugForm" (ngSubmit)="launchApp()" #debuggerForm="ngForm">
      <mat-form-field>
        <mat-label>שותף</mat-label>
        <mat-select formControlName="partner">
          <ng-container *ngFor="let partner of partnersList">
            <mat-option [value]="partner">
              {{ partner }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>מוצר</mat-label>
        <mat-select formControlName="lobCode">
          <ng-container *ngFor="let lob of lobList">
            <mat-option [value]="lob.value">{{ lob.key }} | {{ lob.value }}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>מותג</mat-label>
        <mat-select formControlName="brandCode">
          <ng-container *ngFor="let brand of brandList">
            <mat-option [value]="brand.value">{{ brand.key }} | {{ brand.value }}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>תימה</mat-label>
        <mat-select formControlName="theme">
          <ng-container *ngFor="let partner of partnersList">
            <mat-option [value]="partner">
              {{ partner }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <textarea formControlName="token" #token placeholder="insert TOKEN | UID" (focus)="token.select()"></textarea>

      <mat-checkbox formControlName="isWebMode" indeterminate="false" labelPosition="after"
                    style="color: #fff; margin: 10px 0 0">
        סיגמה ווב?
      </mat-checkbox>

      <ng-container *ngIf="this.router$ | async">
        <mat-form-field>
          <mat-label>לאן לנווט?</mat-label>
          <mat-select formControlName="router" [disabled]="debugForm.invalid" (selectionChange)="navigate($event)">

            <!-- TODO: this option is temp' added until policy returns the amount stage -->
            <mat-option [value]="'amount'">על כמה חשבת?</mat-option>
            <!--------------------------->
            <ng-container *ngFor="let route of router$ | async">
              <mat-option [value]="route.url">
                {{ route.title }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <div style="display: flex; gap: 1.5rem; justify-content: center; flex-wrap: nowrap">
        <div class="reset">
          <button type="reset" mat-stroked-button (click)="resetMockProcess()">איפוס</button>
        </div>

        <div class="submit">
          <button type="submit" mat-raised-button [disabled]="debugForm.invalid">התחל</button>
        </div>
      </div>
    </form>
  </div>
</ng-container>